var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1188 9.55566L17.5704 14.5201L10.8723 9.55566V9.557L10.8804 9.56372V16.5153L17.4949 21.587L24.1188 16.7111V9.55566Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8379 8.34804L24.1182 9.5556V16.7111L29.5295 12.6752V10.2439C29.5295 10.2439 28.8727 6.77149 25.8379 8.34804Z",
    fill: "#FBBC05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1182 16.7107V25.9915H28.2657C28.2657 25.9915 29.4459 25.8735 29.5308 24.5666V12.6748L24.1182 16.7107Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8811 26.0003V16.5155L10.8723 16.5088L10.8811 26.0003Z",
    fill: "#C5221F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.872 9.55683L9.16175 8.35597C6.12696 6.77942 5.46875 10.2505 5.46875 10.2505V12.6817L10.872 16.5084V9.55683Z",
    fill: "#C5221F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8723 9.55762V16.5092L10.8811 16.5159V9.56433L10.8723 9.55762Z",
    fill: "#C5221F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46875 12.6836V24.5754C5.55238 25.8837 6.73392 26.0004 6.73392 26.0004H10.8815L10.872 16.5089L5.46875 12.6836Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/gmail-icon.1b11741d370e6022fd155c296e5f8918.svg";
export { ForwardRef as ReactComponent };